import * as actions from './actionsTypes';

const initialData = {
  loader: false,
  saveLoader: false,
  unidadNodes: {},
  formErrors: '',
  error: ''
}

export default function unidadNodesReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADER_UNIDAD_NODES:
      return {...state, loader: action.payload}
    case actions.SAVE_LOADER_UNIDAD_NODE:
      return {...state, saveLoader: action.payload}
    case actions.GET_UNIDAD_NODES:
      return {...state, unidadNodes: action.payload}
    case actions.UNIDAD_NODE_FAIL:
      return {...state, error: action.payload}
    case actions.UNIDAD_NODE_FORM_FAIL:
      return {...state, formErrors: action.payload}
    default:
      return state
  }
}